import cn from "@utils/cn";
import LinkButton from "@elements/LinkButton";

const DESKTOP_CLASS_NAMES = cn(`
  m-2
  p-2
  size-12
  rounded-xl
  shadow-xl
  hidden
  md:flex
`);

const MOBILE_CLASS_NAMES = cn(`
  m-2
  mr-8
  p-2
  size-12
  rounded-xl
  text-white
  border-0
  flex
  md:hidden

  shadow-none!
  not-disabled:text-(--navbar-foreground-color)
  not-disabled:hover:bg-black/20
  not-disabled:focus:bg-black/20
  not-disabled:focus:outline-none
  not-disabled:active:bg-black/30
`);

export default function CommandPaletteTrigger(_props) {
  return (
    <>
      <LinkButton
        className={DESKTOP_CLASS_NAMES}
        iconName="rocket"
        iconSize="xl"
        color="slate"
        isIconOnly={true}
      />
      <LinkButton
        className={MOBILE_CLASS_NAMES}
        iconName="rocket"
        iconSize="lg"
        color="none"
        isIconOnly={true}
      />
    </>
  );
}
